import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';
import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';

import MonteCarloTasksChart from './MonteCarloTasksChart';

import '../MonteCarloTasks.scss';

class WallboardMonteCarloTasksChart extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Monte Carlo: Number of Tasks</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options chart="mct" showNavigator />
            <DatePicker />
          </div>
        </div>
        <div className="diagram_details">
          <MonteCarloTasksChart id="MonteCarloTasks" data={this.props.data} />
          <NoData show={!this.props.data.length} loading={this.props.isLoading} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.mct.data,
    isLoading: state.mct.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps)(WallboardMonteCarloTasksChart);
